import { CheckOutlined, CloseOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { makeStyles } from '@material-ui/styles';
import { Divider, Timeline, Tooltip } from 'antd';
import EditListingPlan from '../edit-listing-plan';
import React, { useState } from 'react';
import { LandlordRelatedInformation, Edit, ProcessArrow, CheckCircle } from '~components/svgs';
import QuestionIcon from '../icon/question';

const uesStyles = makeStyles(
  theme => ({
    layout: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      backgroundColor: 'white',
      padding: '40px 0',
    },
    diffbox: {
      display: 'flex',
      padding: '12px 20px',
      background: '#FAFAFA',
      borderRadius: '2px',
    },
    bodyRegular: {
      fontSize: '14px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.65)',
      lineHeight: '22px',
    },
    currentPlan: {
      display: 'flex',
      boxShadow: '4px 0px 0px 0px rgba(90, 191, 178, 1) inset',
      padding: '24px 32px',
      background: 'white',
    },
    h3: {
      fontSize: '20px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '32px',
    },
    h5: {
      fontSize: '14px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    body: {
      fontSize: '14px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    small: {
      fontSize: '12px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    description: {
      fontSize: '12px',
      fontWeight: 400,
      color: 'rgba(0, 0, 0, 0.65)',
      lineHeight: '22px',
      minHeight: '66px',
      marginTop: '8px',
      marginBottom: '24px',
      '& .ant-timeline-item': {
        minHeight: '60px',
      },
      '& .ant-timeline-item-content ': {
        ...theme.typography.body2,
        color: theme.colors.bodyColor,
        marginLeft: '30px',
      },
    },
    smallRegular: {
      fontSize: '12px',
      fontWeight: 400,
      lineHeight: '20px',
    },
    arrow: {
      width: '24px',
      height: '12px',
      margin: '0 16px',
      fill: theme.colors.yellow6,
    },
    cardTitle: {
      fontSize: '12px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
      background: '#FAFAFA',
      padding: '12px 24px',
    },
    cardContent: {
      padding: '16px 24px',
    },
    description_title: {
      fontSize: '12px',
      marginTop: '16px',
      fontWeight: 600,
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '22px',
    },
    description_line: {
      display: 'flex',
      fontSize: '12px',
      fontWeight: 400,
      marginTop: '8px',
      color: 'rgba(0, 0, 0, 0.85)',
      lineHeight: '20px',
    },
    tag: {
      backgroundColor: '#F0F7FF',
      borderRadius: '2px',
      padding: '0px 6px',
      color: '#6B92F3',
      display: 'inline-block',
      ...theme.typography.caption,
    },
  }),
  { name: 'SignmeUp-Dialog' },
);
function Index({ data, type, landlordId }) {
  const [currentPlan, setCurrentPlan] = useState(data.filter(d => d.title === type)[0]);

  const otherPlans = data.filter(d => d.title !== currentPlan.title);
  const [open, setOpen] = React.useState(false);
  const getCheckIcon = icon_status =>
    icon_status === 'enabled' ? (
      <CheckCircle
        style={{
          width: '14px',
          flexShrink: 0,
          height: '14px',
          margin: '3px 6px 0 0',
          fill: '#38b2a6',
        }}
      />
    ) : (
      <CloseCircleOutlined
        style={{
          width: '14px',
          flexShrink: 0,
          height: '14px',
          margin: '3px 6px 0 0',
          color: '#BFBFBF',
        }}
      />
    );

  const Difference = React.useMemo(() => {
    let result = {
      usage: 'View Leads',
    };
    if (currentPlan.title === 'Book') {
      result = {
        pays: (
          <>
            <CheckOutlined style={{ color: '#38B2A6' }} />/
            <CloseOutlined style={{ color: '#BFBFBF' }} /> Configurable
          </>
        ),
        chat: <CheckOutlined style={{ color: '#38B2A6' }} />,
        usage: (
          <div>
            Manage Leads
            <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>(Accept / Reject / Counter Offer)</span>
          </div>
        ),
      };
    }
    if (currentPlan.title === 'Connect') {
      result = {
        pays: (
          <>
            <CheckOutlined style={{ color: '#38B2A6' }} />/<CloseOutlined /> Configurable
          </>
        ),
        realtime: <CheckOutlined style={{ color: '#38B2A6' }} />,
        chat: <CheckOutlined style={{ color: '#38B2A6' }} />,
        usage: 'Receive Confirmed Bookings on Student.com Dashboard',
      };
    }
    return result;
  }, [currentPlan.title]);

  const classes = uesStyles();

  return (
    <div>
      <div className={classes.currentPlan}>
        <LandlordRelatedInformation style={{ width: '64px', height: '64px' }} />
        <div style={{ width: '100%', marginLeft: '36px' }}>
          <div style={{ display: 'flex', flex: 1 }}>
            <div className={classes.bodyRegular}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                Your account is currently under listing plan: <strong>{currentPlan.title}</strong>
                {currentPlan.title === 'Connect' && (
                  <>
                    <Divider type="vertical" style={{ margin: '0 12px' }} />
                    <span className={classes.tag} style={{ marginRight: '8px' }}>
                      Student.com Dashboard
                    </span>
                    <Tooltip
                      placement="top"
                      title="If you have your own property management system, we can integrate with it, allowing you to manage orders directly. If interested, please contact your account manager."
                    >
                      <QuestionIcon />
                    </Tooltip>
                  </>
                )}
              </div>
              <div className={classes.small} style={{ color: 'rgba(0, 0, 0, 0.45)' }}>
                {currentPlan.description}
              </div>
            </div>
            <div
              style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}
              onClick={() => {
                setOpen(true);
              }}
            >
              <Edit width="16px" height="8px" style={{ marginRight: '16px', fill: '#38B2A6' }} />
              <div style={{ color: '#38B2A6', cursor: 'pointer', fontWeight: 600 }}>Edit</div>
            </div>
          </div>
          <Divider style={{ margin: '32px 0' }} />

          <div className={classes.bodyRegular}>
            {Difference.realtime && (
              <div
                className={classes.diffbox}
                style={{
                  marginBottom: '12px',
                }}
              >
                <div> Real-Time Inventory</div>
                <div style={{ marginLeft: 'auto' }}>{Difference.realtime}</div>
              </div>
            )}
            {Difference.pays && (
              <div
                className={classes.diffbox}
                style={{
                  marginBottom: '12px',
                }}
              >
                <div> Student Pays to Confirm on Student.com</div>
                <div style={{ marginLeft: 'auto' }}>{Difference.pays}</div>
              </div>
            )}
            {Difference.chat && (
              <div
                className={classes.diffbox}
                style={{
                  marginBottom: '12px',
                }}
              >
                <div>Chat with Students via Student.com Dashboard</div>
                <div style={{ marginLeft: 'auto' }}>{Difference.chat}</div>
              </div>
            )}
            {Difference.usage && (
              <div className={classes.diffbox}>
                <div>Dashboard Usage</div>
                <div style={{ marginLeft: 'auto' }}>{Difference.usage}</div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* student_experience  */}
      <div
        style={{
          background: 'white',
          marginTop: '16px',
          border: '1px solid #0000000F',
          overflowX: 'hidden',
        }}
      >
        <div
          className={classes.h5}
          style={{ padding: '16px 32px', boxShadow: '0px -1px 0px 0px #00000017 inset' }}
        >
          Student Experience
        </div>
        <div
          style={{
            padding: '16px 32px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {currentPlan.student_experience.map((se, idx) => (
            <>
              <div
                key={idx}
                style={{
                  border: '1px solid #0000000F',
                  padding: '24px 32px',
                  minHeight: '200px',
                  width: '340px',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <div
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'rgba(252, 206, 1, 0.2)',
                    }}
                  >
                    {React.cloneElement(se.icon.icon, {
                      style: { width: '22px', height: '22px' },
                    })}
                  </div>
                  <dv className={classes.smallRegular} style={{ marginTop: '16px' }}>
                    {se.action}
                  </dv>
                </div>
              </div>
              {idx !== 2 && <ProcessArrow className={classes.arrow} />}
            </>
          ))}
        </div>
      </div>
      {/* landlord_experience */}
      <div
        style={{
          background: 'white',
          marginTop: '16px',
          border: '1px solid #0000000F',
          overflowX: 'hidden',
        }}
      >
        <div
          className={classes.h5}
          style={{ padding: '16px 32px', boxShadow: '0px -1px 0px 0px #00000017 inset' }}
        >
          Landlord Experience
        </div>
        <div
          style={{
            padding: '24px 32px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {currentPlan.landlord_experience.map((se, idx) => (
            <>
              <div
                key={idx}
                style={{
                  border: '1px solid #0000000F',
                  minHeight: '200px',
                  width: '370px',
                  marginRight: '16px',
                }}
              >
                <div className={classes.cardTitle}>{se.title}</div>
                <div key={idx} style={{ padding: '16px 24px' }}>
                  {se.content.map((ct, index) => (
                    <div key={index} className={classes.description_line}>
                      {getCheckIcon(ct.icon_status)}
                      <div>{ct.description}</div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          ))}
        </div>
      </div>

      {/* Other Listing Plans */}
      <div className={classes.h3} style={{ marginTop: '32px' }}>
        Other Listing Plans
      </div>
      {otherPlans.map((plan, idkey) => (
        <div
          key={idkey}
          style={{ display: 'flex', marginTop: '20px', border: '1px solid rgba(0, 0, 0, 0.06)' }}
        >
          <div style={{ flex: 1, background: 'white', padding: '24px 32px' }}>
            <div className={classes.h3}>{plan.title}</div>
            <div
              style={{
                display: 'flex',
                padding: '12px 20px',
                background: '#FAFAFA',
                borderRadius: '2px',
                marginTop: '12px',
              }}
              className={classes.small}
            >
              {plan.description}
            </div>
            <div
              className={classes.h5}
              style={{ color: 'rgba(0, 0, 0, 0.25)', marginTop: '32px', marginBottom: '16px' }}
            >
              Student Experience
            </div>
            <div className={classes.description} style={{ margin: '32px 0 0 10px' }}>
              <Timeline>
                {plan.student_experience.map((item, index) => (
                  <Timeline.Item
                    key={index}
                    dot={
                      <div
                        style={{
                          backgroundColor:
                            item.icon.status === 'disabled' ? '#E5E5E5' : 'rgba(252, 206, 1, 0.2)',
                          borderRadius: '32px',
                          width: '32px',
                          height: '32px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {item.icon.icon}
                      </div>
                    }
                  >
                    {item.action}
                  </Timeline.Item>
                ))}
              </Timeline>
            </div>

            {/* <Steps progressDot={false} direction="vertical">
              {plan.student_experience.map((item, index) => (
                <Step
                  icon={
                    <div
                      style={{
                        backgroundColor:
                          item.icon.status === 'disabled' ? '#E5E5E5' : 'rgba(252, 206, 1, 0.2)',
                        borderRadius: '32px',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      {item.icon.icon}
                    </div>
                  }
                  key={index}
                  description={item.action}
                />
              ))}
            </Steps> */}
          </div>
          <div style={{ width: '400px', padding: '24px 32px' }}>
            <div>Landlord Experience</div>
            {plan.landlord_experience.map((item, index) => (
              <div key={`items_${index}`}>
                <div className={classes.description_title}>{item.title}</div>
                {item.content.map((ct, idx) => (
                  <div key={idx} className={classes.description_line}>
                    {getCheckIcon(ct?.icon_status)}
                    <div>{ct.description}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ))}
      <EditListingPlan
        landlordId={landlordId}
        data={data}
        setOpen={setOpen}
        open={open}
        type={currentPlan.title}
        callback={changeType => {
          setCurrentPlan(data.filter(item => item.title === changeType)[0]);
        }}
      />
    </div>
  );
}

export default Index;
